import { HttpErrorResponse } from '@angular/common/http';
import { DsmCatalogPdfQuery } from '../models/dsm-options-catalog.models';
import { toDsmApiErrorMessage } from './dsm-api-error.util';
import { DsmCatalogPrice, DsmCatalogUrlState, toCatalogQuery } from './dsm-options-catalog-url-state.util';

export const DSM_CATALOG_PDF_ERROR = 'Could not generate the PDF. Please try again.';

/** The PDF of exactly what the screen shows: same filters and details, and the same prices hidden. */
export function toCatalogPdfQuery(state: DsmCatalogUrlState): DsmCatalogPdfQuery | null {
  const query = toCatalogQuery(state);
  if (!query) return null;

  return {
    ...query,
    hideUnitPrices: state.hiddenPrices.includes(DsmCatalogPrice.Unit),
    hideExtendedPrices: state.hiddenPrices.includes(DsmCatalogPrice.Extended)
  };
}

/**
 * The PDF is requested as a blob, so a refusal (a catalog too large to print, a bad home plan)
 * arrives as a blob too — this reads the API's JSON message back out of it.
 */
export async function readPdfError(error: unknown): Promise<string> {
  if (!(error instanceof HttpErrorResponse) || !(error.error instanceof Blob)) return DSM_CATALOG_PDF_ERROR;

  try {
    return toDsmApiErrorMessage({ error: JSON.parse(await error.error.text()) }, DSM_CATALOG_PDF_ERROR);
  } catch {
    return DSM_CATALOG_PDF_ERROR;
  }
}
